type ValueType = Record<
  string,
  {
    title: string;
    coord: {
      top: string;
      left: string;
    };
  }
>;

export const SHOCKWAVE_SOLUTION_TO_COORDS: Partial<Record<Massage.ModelSolution, ValueType>> = {
  shoulder: {
    '1': {
      title: '左风门到左胆俞',
      coord: { top: '45%', left: '9%' },
    },
    '2': {
      title: '左大杼到左膏肓',
      coord: { top: '32%', left: '7%' },
    },
    '3': {
      title: '左天宗到左阳纲',
      coord: { top: '53%', left: '2%' },
    },
    '4': {
      title: '左大杼到左肩外俞',
      coord: { top: '27%', left: '4.7%' },
    },
    '5': {
      title: '右风门到右胆俞',
      coord: { top: '45%', left: '57.5%' },
    },
    '6': {
      title: '右大杼到右膏肓',
      coord: { top: '32%', left: '59.5%' },
    },
    '7': {
      title: '右天宗到右阳纲',
      coord: { top: '53%', left: '64%' },
    },
    '8': {
      title: '右大杼到右肩外俞',
      coord: { top: '27%', left: '62%' },
    },
  },
  back: {
    '1': {
      title: '左气海俞到左肝俞',
      coord: { top: '69%', left: '9.3%' },
    },
    '2': {
      title: '左气海俞外到左魂门',
      coord: { top: '69%', left: '4%' },
    },
    '3': {
      title: '左肾俞到左志室',
      coord: { top: '69%', left: '4%' },
    },
    '4': {
      title: '左气海俞到左气海俞外',
      coord: { top: '73.5%', left: '4%' },
    },
    '5': {
      title: '右气海俞到右肝俞',
      coord: { top: '69%', left: '58.5%' },
    },
    '6': {
      title: '右气海俞外到右魂门',
      coord: { top: '69%', left: '62.5%' },
    },
    '7': {
      title: '右肾俞到右志室',
      coord: { top: '69%', left: '62.5%' },
    },
    '8': {
      title: '右气海俞到右气海俞外',
      coord: { top: '73.5%', left: '62.5%' },
    },
  },
  'shock-shoulder-teacher-zhai': {
    '1': {
      title: '左肩中俞到左膈俞',
      coord: { top: '36%', left: '9%' },
    },
    '2': {
      title: '左肩外俞到左膈关',
      coord: { top: '36%', left: '5%' },
    },
    '3': {
      title: '左大杼到左神堂',
      coord: { top: '32%', left: '8.6%' },
    },
    '4': {
      title: '右大杼到右膈俞',
      coord: { top: '34%', left: '59.6%' },
    },
    '5': {
      title: '右肩外俞到右膈关',
      coord: { top: '35%', left: '63%' },
    },
    '6': {
      title: '右大杼到右神堂',
      coord: { top: '32%', left: '59%' },
    },
  },
  'shock-waist-teacher-zhai': {
    '1': {
      title: '左肝俞到左气海俞',
      coord: { top: '69%', left: '9.5%' },
    },
    '2': {
      title: '左阳纲到左气海俞外侧',
      coord: { top: '69%', left: '4%' },
    },
    '3': {
      title: '右肝俞到右气海俞',
      coord: { top: '69%', left: '58.3%' },
    },
    '4': {
      title: '右阳纲到右气海俞外侧',
      coord: { top: '69%', left: '62.5%' },
    },
  },
  'shock-shoulder-deji': {
    '1': {
      title: '左大杼到左胆俞',
      coord: { top: '43%', left: '8.6%' },
    },
    '2': {
      title: '右大杼到右胆俞',
      coord: { top: '43%', left: '58.2%' },
    },
  },
  'shock-waist-deji': {
    '1': {
      title: '左脾俞到左次髎',
      coord: { top: '73%', left: '8%' },
    },
    '2': {
      title: '右脾俞到右次髎',
      coord: { top: '73%', left: '58.5%' },
    },
  },
  // 益盛堂方案
  'shock-shoulder-yst-1': {
    '1': {
      title: '',
      coord: { top: '30%', left: '64%' },
    },
    '2': {
      title: '',
      coord: { top: '34%', left: '57%' },
    },
    '3': {
      title: '',
      coord: { top: '36%', left: '62%' },
    },
    '4': {
      title: '',
      coord: { top: '40.6%', left: '64%' },
    },
    '5': {
      title: '',
      coord: { top: '29.6%', left: '2%' },
    },
    '6': {
      title: '',
      coord: { top: '36.6%', left: '10%' },
    },
    '7': {
      title: '',
      coord: { top: '37%', left: '5%' },
    },
    '8': {
      title: '',
      coord: { top: '41%', left: '3%' },
    },
  },
  'shock-waist-yst-1': {
    '1': {
      title: '',
      coord: { top: '71%', left: '58%' },
    },
    '2': {
      title: '',
      coord: { top: '71%', left: '62%' },
    },
    '3': {
      title: '',
      coord: { top: '71%', left: '58%' },
    },
    '4': {
      title: '',
      coord: { top: '71%', left: '9.5%' },
    },
    '5': {
      title: '',
      coord: { top: '71%', left: '5.5%' },
    },
    '6': {
      title: '',
      coord: { top: '71%', left: '9.5%' },
    },
  },
  'shock-waistback-yst-1': {
    '1': {
      title: '',
      coord: { top: '56%', left: '58%' },
    },
    '2': {
      title: '',
      coord: { top: '56%', left: '63%' },
    },
    '3': {
      title: '',
      coord: { top: '41%', left: '62%' },
    },
    '4': {
      title: '',
      coord: { top: '78%', left: '64%' },
    },
    '5': {
      title: '',
      coord: { top: '56%', left: '9.5%' },
    },
    '6': {
      title: '',
      coord: { top: '56%', left: '5.3%' },
    },
    '7': {
      title: '',
      coord: { top: '41%', left: '5.3%' },
    },
    '8': {
      title: '',
      coord: { top: '78%', left: '2%' },
    },
  },
  'shock-waistback-yst-2': {
    '1': {
      title: '',
      coord: { top: '56%', left: '58%' },
    },
    '2': {
      title: '',
      coord: { top: '56%', left: '9.5%' },
    },
    '3': {
      title: '',
      coord: { top: '56%', left: '63%' },
    },
    '4': {
      title: '',
      coord: { top: '56%', left: '5.3%' },
    },
    '5': {
      title: '',
      coord: { top: '41%', left: '62%' },
    },
    '6': {
      title: '',
      coord: { top: '41%', left: '5.3%' },
    },
    '7': {
      title: '',
      coord: { top: '78%', left: '64%' },
    },
    '8': {
      title: '',
      coord: { top: '78%', left: '2%' },
    },
  },
};
